import { createAction, createAsyncAction } from 'lib/store-utils';
import { FormattedErrors } from 'type';
import { GetPageDataSuccessPayload } from './types';

export const BOX_PAY_ELEMENTS_PAGE_DATA_GET = createAsyncAction<void, GetPageDataSuccessPayload, FormattedErrors>('Settings / Pay Elements page / get page data');
export const BOX_PAY_ELEMENTS_PAGE_ERRORS_CLOSED = createAction('Settings / Pay Elements page / errors closed');
export const BOX_PAY_ELEMENTS_PAGE_DIALOG_ERRORS_CLOSED = createAction('Settings / Pay Elements page / dialog / errors closed');
export const BOX_PAY_ELEMENTS_PAGE_DIALOG_OPENED = createAction('Settings / Pay Elements page / dialog / opened');
